import { BotFlow, DialogSchema } from '@feedyou/schema'
import {
  DialogHierarchyMap,
  getEntryPointsThroughWhichDialogIsAccessible,
  isDialogEnabled,
  isDialogUsed
} from '../../dialogRelation'
import { dialogHierarchyMapSelector } from '../../../store/flow/selectors/dialogHierarchyMapSelector'
import type { State as FeaturesState } from '../../../store/features/featuresSlice'

export type Filters = {
  excludeUnused: boolean
  excludeDisabled: boolean
  excludeInaccessible: boolean
}

const defaultFeaturesState: FeaturesState = {
  values: {
    statsig: {},
    userSettings: {},
    devForcedFeatures: {}
  },
  availabilities: null,
  areValuesReady: true,
  isStatsigApiReady: false,
  didStatsigInitFail: false
}

export function filterDialogs(
  dialogsToFilter: DialogSchema[],
  filters: Partial<Filters>,
  hierarchyMap: DialogHierarchyMap
): DialogSchema[] {
  const {
    excludeUnused = false, // I <3 PRETTIER
    excludeInaccessible = false,
    excludeDisabled = false
  } = filters

  const doesDialogSatisfyFilter = (dialog: DialogSchema) => {
    if (excludeUnused && !isDialogUsed(dialog.id, hierarchyMap)) {
      return false
    }

    if (
      excludeInaccessible &&
      !getEntryPointsThroughWhichDialogIsAccessible(dialog.id, hierarchyMap).size
    ) {
      return false
    }

    if (excludeDisabled && !isDialogEnabled(dialog.id, hierarchyMap)) {
      return false
    }

    return true
  }

  return dialogsToFilter.filter(doesDialogSatisfyFilter)
}

// This generates all maps internally - DO NOT USE THIS in performance sensitive contexts.
// Use the normal version and provide store pre-generated maps there instead.
// This is intended for use in tests, and potentially some imperative user-triggered logic
// It can also be useful with manually altered bot structures, which have no map cached in store
filterDialogs.fromBot__perfoHazard = (
  dialogsToFilter: DialogSchema[],
  filters: Partial<Filters>,
  flow: BotFlow
) => {
  // @ts-ignore
  const hierarchyMap = dialogHierarchyMapSelector({
    flow: { present: flow } as any,
    features: defaultFeaturesState as any
  })

  return filterDialogs(dialogsToFilter, filters, hierarchyMap)
}
